module.exports = __webpack_public_path__ + "img/earth.9ae6b3a.png";